import { USER_TYPE , ENTREGA_TYPE } from '@/utils/const';
let { B, C } = USER_TYPE;

export const TICKET_INFO_DATA_SORT = (state, action) => {
    let { requesterName, requesterPhone, requesterPhoneMask, requesterPhonePrefix, requesterType, cityId, businessType, channel, channelType, content, orderId, orderUrl, ticketid, complaintUrl, complaintType, sop, isRoaming, categoryId, groupId, category, associateTicketId, ticketLevel, levelName, assigneeName, groupName, channelName, cityName, businessTypeName, requesterTypeName, complaintPhone, registerPhonePrefix, status, statusName, email, emailMask, driverId, passengerId, isTransferClipper, requesterId, complaintId, extraFieldsDriverGradeValue, extraFieldsDriverGradeName, requesterUrl, utcUpdateTime, searchType, searchValue, tagList, tags, incomingPhone ,extraFieldsIsAsync , flowId, isAnycar, isSelectBusiness, clearOrderDetailBusinessType} = action.payload
    let oldDistrict = state?.order?.district
    let oldIsImBindTicket = state?.ticket?.isImBindTicket
    let { order,tag } = state
    // 设置 driverId
    let myDriverId = driverId
    if(!driverId && requesterType === B){
        myDriverId = requesterId
    }
    // tag sop 结束时候会重新拉取findTicketById 接口。期间如果tag有更改 数据会丢失
    let myTag = tags ? JSON.parse(tags) : []
    if(tag?.length){
        myTag = tag
    }
    return {
        ...state,
        // info: action.payload,
        isHandle: true, // 是否是编辑态 
        // 订单相关
        order: { orderId, orderUrl, orderShowStatus: !!orderId, district: oldDistrict , reallyPassengerId : order?.reallyPassengerId || '', isAnycar},
        // 进线人信息相关
        requester: { requesterUrl, requesterId, requesterName, requesterPhone, requesterPhoneMask, requesterPhonePrefix, requesterType, isRoaming, requesterTypeName, email, emailMask, driverId : myDriverId, passengerId, searchType, searchValue,lastPhone : requesterPhoneMask, incomingPhone },
        // 被投诉人信息相关
        complaint: { complaintUrl, complaintType, complaintPhone, registerPhonePrefix, complaintId },
        // 工单相关
        ticket: {
            ticketid,
            associateTicketId,
            associateTicketIdMask: associateTicketId,
            ticketLevel,
            levelName,
            assigneeName,
            groupName,
            cityId,
            businessType,
            isSelectBusiness,
            clearOrderDetailBusinessType,
            businessTypeName,
            cityName,
            channelName,
            category,
            groupId,
            channel,
            channelType,
            status,
            statusName,
            isTransferClipper,
            grade_value: extraFieldsDriverGradeValue,
            grade_name: extraFieldsDriverGradeName,
            utcUpdateTime,
            categoryId,
            // categoryId : 960051944,
            isEdit: false,
            fetching: false,
            extraFieldsIsAsync,
            isImBindTicket : oldIsImBindTicket
        },
        // 回复信息相关
        message: { content },
        // 人工sop
        sop: { ...sop, submit: false, refresh: true},
        // tag
        tagList,
        // tag: tags ? JSON.parse(tags) : [],
        tag: myTag,
        flowId // sop相关，透传，接口提交时候用 前端无需操作。
    };
};

export const ORDER_INFO_DATA_SORT = (state, action) => {
    let { orderId, birthTime, statusName, startingName, destName, orderUrl, district, driverId, driverPhone, passengerId, passengerPhone, reallyPassengerId } = action.payload?.data || {}
    let newOrderDetails = { orderId, birthTime, statusName, startingName, destName, orderUrl, district, reallyPassengerId }
    let { order, requester } = state
    let { requesterType } = requester
    let complaintData = {
        ...state.complaint,
    };
    if (requesterType === C  || requesterType === ENTREGA_TYPE) {
        // 投诉人是乘客
        complaintData.complaintId = driverId;
        complaintData.complaintPhone = driverPhone;
        complaintData.complaintType = B;
        requester.driverId = driverId
    } else {
        // 投诉人是司机
        complaintData.complaintId = passengerId;
        complaintData.complaintPhone = passengerPhone;
        complaintData.complaintType = C;
        requester.passengerId = passengerId
    }
    const currentData = {
        ...state.data,
        orderDetails: newOrderDetails,
    };
    return {
        ...state,
        data: currentData,
        order: { ...order, district ,reallyPassengerId}, // 添加district
        complaint: complaintData,  // 被投诉人信息
    }
}
